export const iconFontAwesomeLogisticsAnchorCircleXmark = (
	<i className="fa-solid fa-anchor-circle-xmark"></i>
);
